<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

import AdminLayout from "./Layouts/AdminLayout.vue";
import AuthLayout from "./Layouts/AuthLayout.vue";
import BlankLayout from "./Layouts/BlankLayout.vue";
import PublicLayout from "./Layouts/PublicLayout.vue";

const route = useRoute();

const layout = computed(() => {
    switch (route.meta.layout) {
        case "AdminLayout":
            return AdminLayout;
        case "AuthLayout":
            return AuthLayout;
        case "PublicLayout":
            return PublicLayout;
        default:
            return BlankLayout;
    }
});
</script>

<template>
    <component :is="layout">
        <router-view />
    </component>
</template>
